//放弃,无法成正常捕捉404错误
var config = require("../config");
var utils = require("../utils");

var resErrorLogger = {};
var name = "resErrorLogger"
var type = 2
var resHash = {};
/*
报错样例:

 */

function say(msg){
    utils.log(name+" : "+msg);
}

//错误处理函数
function errorTrap(err) {
    var file_url = err.target.src;

    if (config.domainWhitelist.length > 0) {
        if (utils.matchDomains(file_url,config.domainWhitelist) === false){
            say("report ignored because " + file_url + " did not match the whitelist" );
            return;
        }
    }

    if (config.domainIgnore.length > 0) {
        if (utils.matchDomains(file_url,config.domainIgnore) === true){
            say("jsErrorLogger - report ignored because " + file_url + " matched the blacklist" );
            return;
        }
    }
}

var handleError = function(event){
  try {
    if(typeof(event)!="string" && event.target !== window){//过滤掉window的运行时错误,也就是隔壁jsErrorLogger的错误,IE8及以下的err都是string并且404的捕获不到
        if(event.target && event.target.attributes && event.target.attributes instanceof NamedNodeMap){
          say("handleError "+event)
          var res_url = ""
          var attr = "";
          if(event.target.src){
            res_url = event.target.src
          }else if(event.target.href){
            res_url = event.target.href
          }else if(event.target.currentSrc){
            res_url=event.target.currentSrc
          }
          if(res_url!=""){
            var attrObj = {};
            attrObj['tag']=event.target.nodeName.toLowerCase();
            attrObj['res_url'] = utils.encode(res_url);
            attrObj['xt'] = type;
            attrObj['type'] = 1
            // console.log(res_url)
            utils.requestRemote(attrObj);
          }
        }
        return true
    }
  }
  catch(e){
    // throw e;
    say(e);
  }
  return false
}


var logResource = function(){
  var resources = performance.getEntriesByType('resource')
  if(resources && resources.length>0){
    var len = resources.length
    var resource=null
    var jsonObj = {}
    var resource_hash = ""
    for(var i=0;i<len;++i){
      resource = resources[i]
      var start_time = resource.startTime.toFixed(2)||0
      resource_hash = resource.name+"_"+start_time
      if(resHash[resource_hash]){
        continue
      }
      var duration = resource.duration>>0

      if(duration<config.res_duration){
        continue
      }
      // console.log(resource)
      resHash[resource_hash]=1
      jsonObj = {
          res_url:utils.encode(resource.name),
          tag:resource.initiatorType,
          duration:duration,
          start_time:start_time,
          type:2,
          xt:type
      }

      utils.requestRemote(jsonObj);
    }
  }
}

resErrorLogger.handleError = handleError
resErrorLogger.launch=function(){
  if(window.NamedNodeMap){    //IE8及以下不支持
    if(window.performance && window.performance.getEntriesByType && document.addEventListener ){
        window.addEventListener('load',function(){
            setTimeout(logResource,1)
        },false);
    }
  }
}

module.exports = resErrorLogger;


//////////////////
// WEBPACK FOOTER
// ./src/logger/resLogger.js
// module id = 4
// module chunks = 0 1 2